var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('table',{staticStyle:{"width":"100%"}},[_c('tr',[_c('td',[_c('div',{staticClass:"header-text",staticStyle:{"margin-left":"10px"}},[_vm._v("\n                    Bảng tin 4.0 TopCV Miền Nam\n                ")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a5b11ab6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TopCVHeader.vue
// module id = null
// module chunks = 